import { setStorageItem } from '../../useStorage/useStorage'
import { unifySessionInfo } from '../consts/unify'

const resetUnifySession = () => {
  // clear session info
  setStorageItem(unifySessionInfo)
}

export default resetUnifySession
